import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
/**
 * Components: Collection Filter
 * ------------------------------------------------------------------------------
 * Handles filtering of the product grid through tags.
 * - Option checkbox values must be the handleized tag.
 *
 * @namespace collectionFilter
 */

import { on } from '~/helpers/utils';
/**
 * Create a new collection filter instance.
 */

export default (() => {
  /**
   * Global instances.
   */
  const searchParams = new URLSearchParams(window.location.search);
  const currentTags = theme.collection.currentTags;
  /**
   * Selectors.
   */

  const selectors = {
    clear: '[js-collection-filter="clear"]',
    options: '[js-collection-filter="option"]'
  };
  /**
   * Node selectors.
   */

  const nodeSelectors = {
    clear: document.querySelector(selectors.clear),
    options: document.querySelectorAll(selectors.options)
  };
  /**
   * Initiates the component.
   */

  function init() {
    setChangeEvents();
    setClickEvents();
    setOptionDefaults();
  }
  /**
   * Sets the click events.
   */


  function setChangeEvents() {
    [...nodeSelectors.options].forEach(item => {
      on('change', item, event => handleOptionChange(event));
    });
  }
  /**
   * Sets the click events.
   */


  function setClickEvents() {
    if (nodeSelectors.clear) {
      on('click', nodeSelectors.clear, () => removeCurrentTags());
    }
  }
  /**
   * Sets the option checkbox defaults.
   * - Sets checked state, also via Liquid.
   */


  function setOptionDefaults() {
    [...nodeSelectors.options].forEach(item => {
      if (currentTags.includes(item.value)) {
        return;
      }

      item.checked = false;
    });
  }
  /**
   * Handles the option change event.
   * - Creates a new array of tags to update.
   * @param {object} event - The event.
   */


  function handleOptionChange(event) {
    const tag = event.target.value;
    const checked = event.target.checked;
    event.preventDefault();
    setDisabledState();
    return checked ? pushTag(tag) : removeTag(tag);
  }
  /**
   * Pushes the tag to the active filter.
   * @param {string} tag - The tag to push.
   */


  function pushTag(tag) {
    const updatedTags = [...currentTags];

    if (isTagActive(tag)) {
      return;
    }

    updatedTags.push(tag);
    updateCurrentTags(updatedTags);
  }
  /**
   * Removes the tag from the active filter.
   * @param {string} tag - The tag to remove.
   */


  function removeTag(tag) {
    const updatedTags = [...currentTags];
    const tagIndex = updatedTags.indexOf(tag);

    if (!isTagActive(tag)) {
      return;
    }

    updatedTags.splice(tagIndex, 1);
    updateCurrentTags(updatedTags);
  }
  /**
   * Sets the disabled state of the filter.
   * - Should only be used temporarily.
   */


  function setDisabledState() {
    [...nodeSelectors.options].forEach(item => {
      item.disabled = true;
    });
  }
  /**
   * Updates the current_tags object.
   * - Accounts for existing tags and URL params.
   * @param {array} tags - Updated tags.
   */


  function updateCurrentTags(tags) {
    const tagPath = getTagPath(tags);
    const paramsString = getSearchParamsString();
    const pathname = window.location.pathname.split('/');

    if (hasCurrentTags()) {
      pathname.splice(-1, 1);
    }

    searchParams.delete('page');
    window.location.href = "\n      ".concat(pathname.join('/')).concat(tagPath).concat(paramsString, "\n    ");
  }
  /**
   * Returns the tag path part.
   * @param {array} tags - The tags array.
   */


  function getTagPath(tags) {
    return tags.length ? "/".concat(tags.join('+')) : '';
  }
  /**
   * Removes the current_tags object.
   * - Passes an empty array to the update function.
   */


  function removeCurrentTags() {
    updateCurrentTags([]);
  }
  /**
   * Returns if the tag exists in the active tags.
   * @param {string} tag - The tag to test.
   */


  function isTagActive(tag) {
    return currentTags.includes(tag);
  }
  /**
   * Returns if the current_tags exist.
   */


  function hasCurrentTags() {
    return typeof currentTags !== 'undefined' && currentTags.length;
  }
  /**
   * Returns the search params.
   * - Prepends with a question mark if not empty.
   */


  function getSearchParamsString() {
    return searchParams.toString() === '' ? '' : "?".concat(searchParams.toString());
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});